import { ReactNode } from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

type EmptyResultViewProps = {
  message: string;
  suggestion?: string;
  actionsChild?: ReactNode;
  imageChild?: ReactNode;
};

export const EmptyResultView = ({
  message,
  suggestion = '',
  actionsChild,
  imageChild,
}: Readonly<EmptyResultViewProps>) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        height: '430px',
        width: '100%',
      }}
      data-testid="empty-result-view"
    >
      <Box sx={{ marginTop: '32px' }} data-testid="empty-result-body">
        <Typography data-testid="no-results-text" variant="body1">
          No results
        </Typography>
        <Typography
          data-testid="empty-result-message-text"
          sx={{ margin: '16px 0 8px 0' }}
          variant="h3"
        >
          {message}
        </Typography>
        <Typography data-testid="empty-result-suggestion-text" variant="body1">
          {suggestion}
        </Typography>
        <Box
          data-testid="empty-result-child-element"
          sx={{ marginTop: '32px' }}
        >
          {actionsChild}
        </Box>
      </Box>

      {imageChild}
    </Box>
  );
};
